import { SignupCoveragePreference } from '@jerry-serverless/types';

import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';

export const MatchIntroStep: Step = {
  id: 'matchintro',
  pathname: '/matchintro',
  canShow: (appData: AppData) => {
    // Don't ask if user did not select insurance service.
    if (!appData.selectedService?.insurance) {
      return false;
    }
    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }
    return appData.signupParams?.coveragePreference === SignupCoveragePreference.Current;
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Coverage,
};
